const STORAGE_KEY = 'examcat_learning_stats_v1';

/**
 * @returns {{ attempts: Record<string, { scorePercent: number, at: string }> }}
 */
export function readLearningStats() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { attempts: {} };
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && parsed.attempts
      ? parsed
      : { attempts: {} };
  } catch {
    return { attempts: {} };
  }
}

/** @param {string|number} examId */
export function getExamAttempt(examId) {
  const stats = readLearningStats();
  return stats.attempts[String(examId)] ?? null;
}

/**
 * Call from the results flow when integrating with the grading response.
 * @param {string|number} examId
 * @param {number} scorePercent 0–100
 */
export function recordExamAttempt(examId, scorePercent) {
  const stats = readLearningStats();
  stats.attempts[String(examId)] = {
    scorePercent: Math.round(Math.min(100, Math.max(0, scorePercent))),
    at: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
}
